<script>
  import { createEventDispatcher } from "svelte";
  import TextInput from "#lib/sidebar/TextInput.svelte";
  import SelectInput from "#lib/sidebar/SelectInput.svelte";
  import FileIcon from "@local/assets/icons/file.svg";
  import TableIcon from "@local/assets/icons/table.svg";
  import VideoIcon from "@local/assets/icons/file-video.svg";

  import { getSupportVideo } from "#src/api";

  export let group;
  export let newDoc;

  const dispatch = createEventDispatcher();
  const filePath = {
    spreadsheet: "table-lg.svg",
    video: "video-lg.svg",
    other: "internet-link.svg",
  };

  async function addRemoteDocument() {
    if (!newDoc.data.url) return;
    if (newDoc.data.url.startsWith("https://www.loom.com/")) {
      const video = await getSupportVideo(newDoc.data.url);

      if (video?.thumbnail_url) {
        newDoc.data.thumbnail = {
          type: "url",
          url: video.thumbnail_url,
        };
        newDoc.data.embed = {
          type: "loom",
          html: video.html,
          title: video.title,
          width: video.width,
          height: video.height,
        };
      } else {
        newDoc.data.thumbnail = {
          type: "icon",
          path: filePath[newDoc.data.doctype] || filePath.other,
        };
      }
    } else {
      newDoc.data.thumbnail = {
        type: "icon",
        path: filePath[newDoc.data.doctype] || filePath.other,
      };
    }
    group.addDocument(newDoc);
    dispatch("done-uploading");
  }
</script>

<div class="text-center text-sm font-bold">Create New Remote Link</div>
<TextInput label="Name" labelWidth="10rem" bind:value={newDoc.name} border inputOnKeydown />
<SelectInput
  label="Remote Document Type"
  labelWidth="10rem"
  border
  options={[
    { label: "Spreadsheet", value: "spreadsheet", icon: TableIcon },
    { label: "Video", value: "video", icon: VideoIcon },
    { label: "Other", value: null, icon: FileIcon },
  ]}
  bind:value={newDoc.data.doctype} />
<TextInput label="URL" labelWidth="10rem" bind:value={newDoc.data.url} border inputOnKeydown />
<button class="btn btn-primary w-full" disabled={!newDoc.data.url} on:click={addRemoteDocument}>
  Link Remote Document
</button>
